// The WHEEL game renders through Pixi, whose Assets.load picks its parser from the file extension,
// not the MIME type: an "image/jpeg" .jfif uploads fine then falls back to the default TGC logo.
// This is @pixi/assets v7 loadTextures' list minus .avif (Safari < 16), which the other games' <img> also handle.
export const SUPPORTED_LOGO_EXTENSIONS = ["png", "jpg", "jpeg", "webp"];
export const MAX_LOGO_BYTES = 5 * 1024 * 1024;

export const LOGO_ACCEPT = "image/png,image/jpeg,image/webp";

export const isSupportedLogo = (fileName: string) =>
  SUPPORTED_LOGO_EXTENSIONS.includes(fileName.split(".").pop()?.toLowerCase() ?? "");

// The S3 key and the CDN URL are built by string concat, so spaces/accents/& in a filename 404 silently.
// ponytail: non-ASCII chars collapse to "-" instead of being transliterated; good enough for a logo key.
export const sanitizeLogoName = (fileName: string) =>
  fileName
    .toLowerCase()
    .replace(/[^a-z0-9.]+/g, "-")
    .replace(/-+/g, "-");
